import PropTypes from 'prop-types';
import React, { memo, useContext } from 'react';

import { bemGenerator } from '@prisjakt/ui-base';
import { AppContext } from '@prisjakt/ui-app-context';
import Button from '@prisjakt/ui-button';
import T from '@prisjakt/ui-translate';

import './index.scss';

const styles = bemGenerator('not-found', [
  'media',
  'content',
  'button',
  'error-label',
  'support-label',
  'text',
]);

/*
  When using compose from DataContainer we can only get
  the contexts requested by the DataContainer component.
*/
const ErrorMessage = ({ status, onRetry }) => {
  const {
    market: { cdn },
  } = useContext(AppContext);

  return (
    <div className="row">
      <div className={styles.block}>
        <div className={styles.media}>
          <img alt="Error" src={`${cdn}/rfe/g/error_page_io.png`} />
        </div>

        <div className={styles.content}>
          <div>
            <h1 className={styles.text}>
              <T domain="errors">error-page.title</T>
            </h1>
            {status === 404 && (
              <h2 className={styles.text}>
                <T domain="errors">internal.404</T>
              </h2>
            )}
            {status > 499 && (
              <h2>
                <T domain="errors">internal.unknown</T>
              </h2>
            )}
            <div className={styles.button}>
              {onRetry && (
                <Button onClick={onRetry} styling="primary">
                  <T domain="errors">error-page.retry-button</T>
                </Button>
              )}
              {!onRetry && (
                <a href="/">
                  <Button styling="primary">
                    <T domain="errors">error-page.go-home-button</T>
                  </Button>
                </a>
              )}
            </div>
          </div>

          {status > 499 && (
            <div className={styles['support-label']}>
              <T domain="errors">support.text-link.md</T>
            </div>
          )}

          {status && (
            <div className={styles['error-label']}>
              <T domain="errors" code={status}>
                error-page.error-code
              </T>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

ErrorMessage.propTypes = {
  message: PropTypes.string,
  stack: PropTypes.string,
  status: PropTypes.number,
  onRetry: PropTypes.func,
};

ErrorMessage.defaultProps = {
  status: 500,
  message: undefined,
  stack: undefined,
  onRetry: undefined,
};

export default memo(ErrorMessage);
